import Link from "next/link";
import { useRouter } from "next/router";
import { gql, useQuery } from "@apollo/client";
import { Col, Row } from "react-bootstrap";

import handleStaticProps from "src/lib/handle-static-props";
import Pagination from "@/components/Pagination";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/seo";
import Loader from "@/components/common/Loader/Loader";
import Image from "@/components/Image";

export async function getStaticProps() {
  const { result } = await handleStaticProps({
    pageQuery,
    variables: { page: 1 },
  });

  return result;
}

function DeejayIndexPage({ staff, query = pageQuery }) {
  const router = useRouter();
  const page = parseInt(router.query.page) || 1;
  const { data } = useQuery(query, {
    variables: { page },
  });

  return (
    <div className="container">
      <Seo title={staff ? "Staff" : "Deejays"} />
      <PageHeader>KVRX {staff ? "Staff" : "DJs"}</PageHeader>
      {data ? (
        <>
          <Row className="row-cols-2 row-cols-lg-4 px-lg-5">
            {data.allDeejays.edges.map((dj) => (
              <Col key={dj.id} sm={3} className="mb-3">
                <div className="card shadow">
                  <Link href={dj.url}>
                    <a>
                      <Image
                        src={
                          dj.pic
                            ? dj.pic
                            : "/static/main/images/defaultAvatar.jpg"
                        }
                        width={225}
                        height={225}
                        layout="responsive"
                        alt={dj.dj}
                        className="card-img-top"
                      />
                      <div className="card-body text-center">
                        <p className="card-text" id="post-title">
                          <em>{dj.dj.toUpperCase()}</em>
                        </p>
                      </div>
                    </a>
                  </Link>
                </div>
              </Col>
            ))}
          </Row>
          <Pagination
            activePage={data.allDeejays.page}
            maxPages={data.allDeejays.pages}
            pageRangeDisplayed={3}
          />
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
}

export default DeejayIndexPage;

const pageQuery = gql`
  query Deejays($page: Int) {
    allDeejays(page: $page) {
      page
      pages
      edges: objects {
        __typename
        id
        pic
        dj
        url
      }
    }
  }
`;
